import React from "react";
import { Link } from "gatsby-plugin-intl";
import LinkArrow from "../../assets/LinkArrow";
import LocationPin from "../../assets/LocationPin";
import cssClass from "./CustomLink.module.scss";

const CustomLink = ({ children, to, style }) => {
  return (
    <Link to={to} className={cssClass.link}>
      {style === "directions" && (
        <span className={cssClass.directions}>
          <LocationPin />
        </span>
      )}
      {children}
      {style === "arrow" && (
        <span className={cssClass.arrow}>
          <LinkArrow />
        </span>
      )}
    </Link>
  );
};

export default CustomLink;
